import React from 'react';
import { SearchHistoryPage } from '../../search/SearchHistoryPage';

export default function EnterpriseSearchHistoryPage() {
  return <SearchHistoryPage />;
}
